// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"style_mainContainer__CrinJ","innerContainer":"style_innerContainer__vYsYx"};